import { render } from "./AquacredCredentials.vue?vue&type=template&id=34557f1c"
import script from "./AquacredCredentials.vue?vue&type=script&lang=js"
export * from "./AquacredCredentials.vue?vue&type=script&lang=js"

import "./AquacredCredentials.vue?vue&type=style&index=0&id=34557f1c&lang=scss"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__